$(document).ready(function() {
    $('.ts_collection_title').click(function(e) {
        var name= $(this).attr('data-name');
        var imgURL = $(this).attr('data-img-url');
        $( ".banner-title" ).replaceWith("<h2 class='banner-title'>"+name+"</h2>");
        $( ".img-url-banner" ).replaceWith('<img src="'+imgURL+' | img_url: \'master\'" alt="" class="img-url-banner"></figure>');
    });
});